import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="open-consumable-modal"
export default class extends Controller {
  static targets = [
    "modal",
    "modalImage",
    "modalInfo",
    "modalDate",
    "modalNav",
  ];

  connect() {
    // Add hover listeners for image preloading
    this.element.addEventListener("mouseover", this.preloadOnHover.bind(this));
    this.currentImageIndex = 0;
  }

  disconnect() {
    this.element.removeEventListener(
      "mouseover",
      this.preloadOnHover.bind(this),
    );
  }

  preloadOnHover(e) {
    if (e.target.dataset.modalImageSrc && !e.target.dataset.preloaded) {
      const img = new Image();
      img.src = e.target.dataset.modalImageSrc;
      e.target.dataset.preloaded = "true";
    }
  }

  openModal(e) {
    e.preventDefault();

    // Get image data from the clicked element
    const imageIndex = parseInt(e.target.dataset.imageIndex);
    this.currentImageIndex = imageIndex;

    // Update modal content
    this.modalImageTarget.src = e.target.dataset.modalImageSrc;
    this.modalInfoTarget.textContent = e.target.dataset.consumableInfo;
    this.modalDateTarget.textContent = `${e.target.dataset.consumedAt}, ${e.target.dataset.mealCategory}`;

    // Update navigation buttons
    this.updateNavigationButtons();

    // Show the modal
    this.toggleModal(true);
  }

  closeModal(e) {
    e.preventDefault();
    this.toggleModal(false);
  }

  toggleModal(show) {
    const modal = this.modalTarget;

    if (show) {
      modal.style.display = "flex";
      modal.style.opacity = "1";
      modal.style.visibility = "visible";
    } else {
      modal.style.display = "none";
      modal.style.opacity = "0";
      modal.style.visibility = "hidden";
    }
  }

  previousImage(e) {
    e.preventDefault();
    this.navigateToImage(this.currentImageIndex - 1);
  }

  nextImage(e) {
    e.preventDefault();
    this.navigateToImage(this.currentImageIndex + 1);
  }

  navigateToImage(targetIndex) {
    // Find all images with data-image-index
    const allImages = this.element.querySelectorAll("[data-image-index]");

    // Find the image with the target index
    const targetImage = Array.from(allImages).find(
      (img) => parseInt(img.dataset.imageIndex) === targetIndex,
    );

    if (targetImage) {
      // Update current index
      this.currentImageIndex = targetIndex;

      // Update modal content with new image data
      this.modalImageTarget.src = targetImage.dataset.modalImageSrc;
      this.modalInfoTarget.textContent = targetImage.dataset.consumableInfo;
      this.modalDateTarget.textContent = `${targetImage.dataset.consumedAt}, ${targetImage.dataset.mealCategory}`;

      // Update navigation button states
      this.updateNavigationButtons();
    }
  }

  updateNavigationButtons() {
    // Find all images to determine total count
    const allImages = this.element.querySelectorAll("[data-image-index]");
    const totalImages = allImages.length;

    // Find previous and next buttons
    const prevButton = this.modalNavTarget.querySelector(
      '[data-action*="previousImage"]',
    );
    const nextButton = this.modalNavTarget.querySelector(
      '[data-action*="nextImage"]',
    );

    // Update button states
    if (prevButton) {
      prevButton.disabled = this.currentImageIndex <= 0;
    }

    if (nextButton) {
      nextButton.disabled = this.currentImageIndex >= totalImages - 1;
    }
  }
}
